import { render, staticRenderFns } from "./RevenueBarChart.vue?vue&type=template&id=7d771f00&scoped=true"
import script from "./RevenueBarChart.vue?vue&type=script&lang=js"
export * from "./RevenueBarChart.vue?vue&type=script&lang=js"
import style0 from "./RevenueBarChart.vue?vue&type=style&index=0&id=7d771f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d771f00",
  null
  
)

export default component.exports